export const tagName = 'back-office-app';
